export const FieldSchema = [
  {
    text: 'Number of Users',
    note: 'Note: Employees with a computer and mail/cloud storage account',
    name: ['numberOfUser', 'numberOfUserPrice'],
    placeholder: 'Enter the quantity',
    price: 10,
    isRequired: true
  },
  {
    text: 'Number of Bundled Users',
    note: 'Note: Only for use on qualifying 5G+ Business Mobility Complete plans',
    name: ['numberOfEndpoints', 'numberOfEndpointsPrice'],
    placeholder: 'Enter the quantity',
    price: 0,
    isRequired: false
  }
];
